import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { environment } from "../environments/environment";
import { LoginGuard } from "./auth/login-guard.service";
import { ModulePreloadingStrategy } from "./module-preloading-strategy";
import { HomePageUrlService } from "./platform/api/url-guards/home-page-url.service";
import { AccessDeniedComponent } from "./platform/error/access-denied/access-denied.component";
import { PageNotFoundComponent } from "./platform/error/page-not-found/page-not-found.component";
import { PlatformComponent } from "./platform/platform.component";
import { DevelopmentGuard } from "./zdevcontrols/development-guard.service";

const routes: Routes = [
  { path: "login", loadChildren: () => import("./auth/auth.module").then(m => m.AuthModule) },
  {
    path: "",
    component: PlatformComponent,
    children: [
      { path: "", canActivate: [HomePageUrlService], component: HomePageUrlService },
      { path: "reporting", loadChildren: () => import("./platform/modules/reporting/reporting.module").then(m => m.ReportingModule), data: { preload: true } },
      { path: "admin", loadChildren: () => import("./platform/modules/admin/admin.module").then(m => m.AdminModule), data: { preload: true } },
      { path: "403", component: AccessDeniedComponent },
      { path: "404", component: PageNotFoundComponent },

    ],
    canActivate: [LoginGuard],
  },
  { path: "**", redirectTo: "404" },
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    {
      enableTracing: false, // !environment.production, // <-- debugging purposes only
      preloadingStrategy: environment.production ? ModulePreloadingStrategy : null,
    }
  )],
  exports: [RouterModule],
  providers: [
    ModulePreloadingStrategy,
  ],
})
export class AppRoutingModule { }
